/* global axios */
import ApiClient from '../ApiClient';

class FinancialBankAccountsAPI extends ApiClient {
  constructor() {
    super('financeiro/bank_accounts', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { financial_bank_account: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { financial_bank_account: data });
  }
}

export default new FinancialBankAccountsAPI();
